// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3000":"14402614b291dfcc","5997":"dd132f7d6735d627"}[chunkId] + ".css";
};